/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */

import { initReactI18next, useTranslation } from "react-i18next";
import { CONFIG_MASTER_ENUM, STEP_MASTER_ENUM } from "../../constants/constant";
import { DOCUMENT_SCAN, HOME, KEY, UPGRADE, FACE_VERIFICATION } from "../../routes/Paths";
import ErrorPopup from "../LoaderAndNotification/ErrorPopup";
import FlipDocumentModal from "../Layout/Card/FlipDocumentModal";
import Header from "../Layout/Header";
import LoaderPopup from "../LoaderAndNotification/LoaderPopup";
import LottieHelper from "../../../src/components/Layout/LottieHelper";
import SuccessPopup from "../LoaderAndNotification/SuccessPopup";
import { getModuleConfiguration } from "../../store/Checkin/moduleConfigurationSlice";
import { getSelectedLanguage } from "../../store/Checkin/languageSlice";
import i18n from "i18next";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import PriorityBadge from "../Layout/PriorityBadge";
import {
  getScanDocumentCurrentCountOfGuest
} from "../../store/Checkin/Scan/documentScanSlice";
import {
  getConfigurationCode,
  getParametersFromLocalStorage,
  getStepMaster,
  saveIntoLocalStorage
} from "../../helpers/commonHelper";
import { useNavigate, useParams } from "react-router-dom";
import { Upgrade } from "@mui/icons-material";

const DocumentVerification = ({
  loading,
  reservationData,
  openModal,
  userData,
  openMaskModal,
  closeErrorModal,
  erroModalData,
  scanDocumentHandler,
  successLoader,
  successMessage,
  flipModalToggle,
  completedScanDone,
  guestCount,
  totalCount,
  show,
  currentProfile: currentProfile,
  documentTypes,
  onBackPressed,
  lastName,
  isPrimaryGuest,
  closeModel,
  isChild,
}) => {
  const navigate = useNavigate();
  const {t} = useTranslation();
  const stepMaster = useSelector((state) => getModuleConfiguration(state));
  const documentScanPage =
    stepMaster && stepMaster.length > 0
      ? stepMaster.find((ele) => ele.stepCode === STEP_MASTER_ENUM.SCAN_DOCUMENT_PAGE)
      : null;
  const stepReservationPage = getStepMaster(
    stepMaster,
    STEP_MASTER_ENUM.HOME_PAGE
  );
  const stepDocumentScanPage = getStepMaster(
    stepMaster,
    STEP_MASTER_ENUM.SCAN_DOCUMENT_PAGE
  );
  const enableSkipAccompanyDocument = getConfigurationCode(
    stepDocumentScanPage?.configs,
    CONFIG_MASTER_ENUM.SKIP_ACCOMPANY_DOCUMENT
  ) ?? false;

  const adultChildCountChangeRequired =
    getConfigurationCode(
      stepReservationPage?.configs,
      CONFIG_MASTER_ENUM.CHILDCOUNT_CHANGE_REQUIRED
    ) ?? false;
    
  //const activeDocumentTypes = documentTypes.filter((item) => item.ActiveFlag);
  const activeDocumentTypes = Array.from(
    new Map(
      documentTypes
        .filter((item) => item.ActiveFlag) // Only active items
        .map((item) => [`${item.DocumentName}-${item.Description}`, item])
    ).values()
  );

  const listItems = activeDocumentTypes.map((item, index) => (
    <li key={index}>{t(item.Description)}</li>
  ));

    const skipAccompany = async () => {
    try {
      loading = true;
      var totalCount = getParametersFromLocalStorage("totalCount");
      var childCount = getParametersFromLocalStorage("childCount");
      if (adultChildCountChangeRequired) {
        if(totalCount == (childCount + 1)) {
          childCount = childCount - 1;
          totalCount = totalCount - 1;
        } else {
          totalCount = totalCount - 1;
        }
      } else {
        if(totalCount > 1) {
          totalCount = totalCount - 1;
        } else {
          if(childCount > 0) {
            childCount = childCount - 1;
          }
        }
      }
      saveIntoLocalStorage("totalCount", totalCount);
      saveIntoLocalStorage("totalGuestCount", totalCount);
      saveIntoLocalStorage("childCount", childCount);
      if ((totalCount - guestCount) == 0 && !(childCount > 1)) {
          loading = false;
          navigate(UPGRADE, { replace: true });
      } else {
          loading = false;
          navigate(FACE_VERIFICATION, { replace: true });
      }
    } catch (error) { }
  };

  const selectedLanguage = useSelector(getSelectedLanguage);

  useEffect(async () => {
    i18n.changeLanguage(selectedLanguage);
  }, []);

  return (
    <div>
      <main>
        <div className="main-content">
          <div className="h-100">
            <div
            style={{
              position: "absolute",
              top: "40px",
              right: "20px",
              zIndex: 10,
            }}
          >
            {/* <PriorityBadge reservationData={reservationData} /> */}
            <PriorityBadge />
          </div>
            <div className="content-bg h-100">
              <div className="row h-100">
                <div className="col-sm-4 pl-0">
                  <div className="h-100">
                    <div>
                      <Header
                        onClick={onBackPressed}
                        setShowModal={openModal}
                        isHome={true}
                          title={""}
                        subTitle={""}
                      />
                    </div>

                    <LoaderPopup loading={loading} />
                    <ErrorPopup
                      closeErrorModal={closeErrorModal}
                      erroModalData={erroModalData}
                    />
                    <SuccessPopup
                      loading={successLoader}
                      successMessage={successMessage}
                    />
                    <FlipDocumentModal
                      completedScanDone={completedScanDone}
                      flipModalToggle={flipModalToggle}
                      closeModel={closeModel}
                    />

                    <div className="scan-content-left-page  text-center ">
                      <div className="mt-115 justify-content-center">
                        <div className="scan-text">
                          <h5 className="text-center font-14 font-weight-500 font-scan" >
                            {lastName && (
                              <>
                                {t("Hey")}{" "}
                                <strong>
                                  {lastName}
                                  {t("Comma")?.trim()}
                                </strong>
                              </>
                            )}
                          </h5>
                          <br />
                          <div
                            className="text-center font-14 font-weight-500"
                            style={{ padding: "10px" }}
                          >
                            {isChild ? (
                              <>
                                <h5 className="text-center font-14 font-weight-500 scan-text">
                                  {t("Place the valid document of the child on the")}{" "}
                                  {t("scanner")}.
                                </h5>

                                <h5>{t("Tap Scan to begin.")}</h5>
                              </>
                            ) : !isChild && !isPrimaryGuest ? (
                              <>
                                <h5 className="text-center font-14 font-weight-500 scan-text">
                                  {t(
                                    "Place the valid document of the accompanying"
                                  )}{" "}
                                  {t("guest on the scanner.")}
                                </h5>

                                <h5>{t("Tap Scan to begin.")}</h5>
                              </>
                            ) : (
                              <>
                                <h5 className="text-center font-14 font-weight-500 scan-text">
                                  {t("Place valid document on the scanner.")}
                                </h5>

                                <h5>{t("Tap Scan to begin.")}</h5>
                              </>
                            )}
                          </div>
                        </div>
                        <div className="text-center mt-30">
                          {show === true ? (
                            <button id="btn-docverify-scan"
                              onClick={() => {
                                scanDocumentHandler();
                              }}
                              className="btn button-blue scan-btn"
                              // onClick={()=>{setShowMaskModal(true)}}
                            >
                              <i className="bx bx-barcode-reader scan-icon"></i>
                              {t("Scan")}
                            </button>
                          ) : (
                            <>
                              <progress class="linear-pgb mb-0" />
                            </>
                          )}
                        </div>
                        {enableSkipAccompanyDocument && !isPrimaryGuest && (
                          <div>
                            <button id="btn-upgrade-skip"
                              className="btn skip-btn py-2 px-3"
                              data-bs-toggle="modal"
                              data-bs-target="#skip-modal"
                              onClick={() => {
                                //skipModal();
                                skipAccompany();
                              }}
                            >
                              {t("Skip")}
                            </button>
                          </div>
                        )}

                        <br />
                        {listItems && listItems?.length > 0 && (
                          <>
                            <div className="down-text scan-text">
                              <h5
                                className="text-center font-14 font-weight-500"
                                style={{ marginTop: "20px" }}
                              >
                                {t("Supported documents")}:
                              </h5>
                              <div className="bullet">
                                <ul style={{ textAlign: "start" }}>
                                  {listItems}
                                </ul>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-8 pr-0">
                  {/* <div className="scan-img">
                    <img src="./assets/images/scan.gif" alt="" />
                  </div>
                   */}
                  {documentScanPage?.stepImage?.includes(".json") ? (
                    <>
                      <LottieHelper animationData="passport_scan.json" />
                    </>
                  ) : (
                    <>
                       <img src={documentScanPage?.stepImage} alt="" style={{backgroundSize:"cover", width:"100%"}} />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default DocumentVerification;
